var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "#13ACC5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83806 4.14878L1.29343 0.144512C1.18754 0.0512195 1.04637 0 0.896886 0C0.747405 0 0.606228 0.0512195 0.502422 0.144512L0.168166 0.439024C-0.049827 0.631098 -0.049827 0.943902 0.168166 1.13415L3.98616 4.49817L0.164014 7.86585C0.0581315 7.95732 0 8.08171 0 8.21341C0 8.34512 0.0581315 8.46951 0.164014 8.56098L0.49827 8.85549C0.604152 8.94878 0.743253 9 0.892734 9C1.04221 9 1.18339 8.94878 1.2872 8.85549L5.83806 4.84756C5.94394 4.75427 6.00208 4.62988 6 4.49817C6.00208 4.36646 5.94394 4.24207 5.83806 4.14878Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.f11ef319e2bd276c7a6946bc405f84a0.svg";
export { ForwardRef as ReactComponent };